import colors from 'theme/colors';
import { StationIconProps } from './types';

export const Info = ({ background = colors.darkBlue, color = colors.white, ...rest }: StationIconProps) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <circle cx="16" cy="16" r="16" fill={background} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5 8C14.5 7.17157 15.1716 6.5 16 6.5H16.02C16.8484 6.5 17.52 7.17157 17.52 8C17.52 8.82843 16.8484 9.5 16.02 9.5H16C15.1716 9.5 14.5 8.82843 14.5 8Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 14C12.5 13.1716 13.1716 12.5 14 12.5H16C16.8284 12.5 17.5 13.1716 17.5 14V20.5H18C18.8284 20.5 19.5 21.1716 19.5 22C19.5 22.8284 18.8284 23.5 18 23.5H16C15.1716 23.5 14.5 22.8284 14.5 22V15.5H14C13.1716 15.5 12.5 14.8284 12.5 14Z"
                fill={color}
            />
        </svg>
    );
};
